import "esbuild-css-modules-plugin-ns-css:src/js/components/progressBar/progressBar.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/progressBar/progressBar.module.css:injector.js";
export default new Proxy({
  "mobileIndicator": "progressBar-module__mobileIndicator_-6VWcW__1100",
  "progressBar": "progressBar-module__progressBar_-6VWcW__1100",
  "progressContainer": "progressBar-module__progressContainer_-6VWcW__1100",
  "progressFill": "progressBar-module__progressFill_-6VWcW__1100",
  "progressStep": "progressBar-module__progressStep_-6VWcW__1100",
  "progressStepActive": "progressBar-module__progressStepActive_-6VWcW__1100",
  "stepNumber": "progressBar-module__stepNumber_-6VWcW__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      